import React from 'react';
export default function SquareFace({
  skinTone,
}) {
  return (
<><g transform="translate(0 -263.133)" fill={skinTone}><path d="M11.832 284.847s2.934.68 2.94 1.825c.005 1.307.048 2.717.048 2.717l4.826.041s-.06-1.408-.02-2.758c.039-1.243 2.617-1.825 2.617-1.825z"/><rect width="22.496" height="17.833" x="5.749" y="267.113" ry="4.605"/><path d="M16.976 287.335a13.86 9.84 0 0 0-5.602.853 6.222 6.222 0 0 0 5.824 4.042 6.222 6.222 0 0 0 5.772-3.914 13.86 9.84 0 0 0-5.994-.981z"/></g><path d="M11.832 21.713s2.592.601 2.908 1.624h4.917c.289-1.104 2.586-1.624 2.586-1.624z" fillOpacity=".103"/></>); }
